import React from "react";
import styled from "styled-components";
import background from "assets/images/background.png";
import b1 from 'assets/images/b1.png'
import b1dark from 'assets/images/b2.png'
import RecentActivities from "components/Home/RecentActivities";
import Header from "components/Header";
// import { useGetWalletQuery } from "generated/graphql";

const Div = styled.div`
  position: relative;
  /* padding-top: 1rem; */
  padding-bottom: 1.5rem;

  .just {
    display: flex;
    width: 100%;
    justify-content: end;
  }

  .f {
    flex-direction: column;
    justify-content: center;
    max-width: 158px;
    height: 79px;
    margin: 0 auto;
    background: rgba(255, 255, 255, .62);
    border: 1px solid rgba(212, 226, 250, 0.38);
    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 4px 4px rgba(232, 232, 232, 0.25);
  }

  .bal {
    font-size: 1.31rem;
  }

  .todo,
  .activity {
    color: #b3b6ba;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .refresh,
  .see {
    color: #4285f4;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .complete {
    font-size: 1rem;
  }

  .to-cont {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .carousel .control-dots {
    position: absolute;
    top: 50px;
  }
`;

function MinorHome() {
  // const { data: walletData } = useGetWalletQuery();
  return (
    <Div>
      <div className="sticky top-0 z-50 bg-white dark:bg-[#010A18] shadow-md pb-10 mb-4">
        <Header />
      </div>
      <RecentActivities />
    </Div>
  );
}

export default MinorHome;
